import MasterCardImgFlipSling from "../components/MasterCardImgFlipSling";

const SlingBag = () => {
    return (
      <MasterCardImgFlipSling />
    );
}

export default SlingBag;